import { useNavigate } from "react-router-dom";

export function use404Page(shouldRedirect = false) {
    const navigate = useNavigate();

    if (shouldRedirect) {
        navigate("/404");
    }
}
